module.exports = __webpack_public_path__ + "static/gatsby-2e9d992ece3fbc946962d7ca485dbda8.png";